import React from 'react';
import './NumericFormat.css';

export default class NumericFormat extends React.Component {

  render() {
    const {props} = this;
    const number_text = parseFloat(
        parseFloat(props.children || '0').toFixed(2));
    const formatted_number = number_text.toLocaleString(
        props.language,
        {
          minimumFractionDigits: props.digit,
          maximumFractionDigits: props.digit,
        });
    const divStyle = {};
    return (
        <div className={props.className}>{formatted_number || '-'}</div>
    );
  }
}

NumericFormat.defaultProps = {
  className: 'inline-div',
  language: navigator.language,
  digit: 2,
};



// WEBPACK FOOTER //
// ./src/component/element/NumericFormat.js